import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import EmojiIcon from '@src/assets/icons/emoji.svg';
import Picker, { EmojiStyle, Theme } from 'emoji-picker-react';
import { useRef, useState } from 'react';
import { IconButton } from "../../../../icon-button";
import ChipInput from "../../../../input/ChipInput";
import { useOutside } from "../../../../../hooks/useOutside";
const EmojiPicker = ({ val, onChange, errors, nativeID, disabled, }) => {
    const [showPicker, setShowPicker] = useState(false);
    const valArr = (Array.isArray(val) ? val : []).map((valEl) => {
        return valEl;
    });
    const ref = useRef();
    useOutside(ref, () => {
        setShowPicker(false);
    });
    return (_jsxs("div", Object.assign({ style: { position: 'relative', opacity: disabled ? 0.5 : 1, width: 300 }, id: nativeID }, { children: [!!disabled && (_jsx("div", { style: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    zIndex: 1,
                } })), _jsxs(EmojiInput, { children: [_jsx(ChipInput, { error: errors === null || errors === void 0 ? void 0 : errors.val, onChipsChange: onChange, chipsContainerCustomStyle: {
                            padding: '0px 32px 0px 8px',
                        }, createChipKeys: [13, 188], placeholder: 'add emojis', chips: valArr }), _jsx(EmojiContainer, { children: _jsx(IconButton, { Icon: EmojiIcon, onClick: () => setShowPicker(true) }) }), showPicker && (_jsx("div", Object.assign({ ref: ref, className: "absolute-picker" }, { children: _jsx(Picker, { previewConfig: { showPreview: false }, skinTonesDisabled: true, searchDisabled: true, theme: Theme.DARK, emojiStyle: EmojiStyle.NATIVE, onEmojiClick: (emoji) => {
                                const exists = valArr.find((em) => emoji.emoji === em);
                                if (exists)
                                    return;
                                onChange === null || onChange === void 0 ? void 0 : onChange([
                                    ...valArr,
                                    emoji.emoji,
                                ]);
                            } }) })))] })] })));
};
export default (props) => _jsx(EmojiPicker, Object.assign({}, props));
const EmojiContainer = styled.div `
	position: absolute;
	right: 0;
	top: 0;
`;
const EmojiInput = styled.div `
	input {
		pointer-events: none;
	}
	.absolute-picker {
		position: absolute;
		top: 50px;
		z-index: 1;
	}
`;
//# sourceMappingURL=EmojiPicker.js.map